import R from "ramda";
import { getThisFinancialYear } from "utils/financial-year";

export const getFiltersFromUrl = (filters, route, router, currency, customTabs) => {
  if (route.path === "this-financial-year") {
    return R.merge(filters, getThisFinancialYear(currency));
  }

  if (route.path === "custom/:customTab") {
    return R.find(R.propEq("id", router.params.customTab))(customTabs).filters;
  }

  if (!router.params.filter || route.path === "all") {
    return filters;
  }

  return getFiltersFromQueryString(filters, router.params.filter);
};

const getFiltersFromQueryString = (filters, qs) => {
  const pairs = qs.split("&");
  const result = {};
  pairs.forEach((p) => {
    const pair = p.split("=");
    const key = pair[0];
    const value = decodeURIComponent(pair[1] || "");

    if (result[key]) {
      if (Object.prototype.toString.call(result[key]) === "[object Array]") {
        result[key].push(value);
      } else {
        result[key] = [result[key], value];
      }
    } else {
      result[key] = value;
    }
  });
  const smoothedResult = smoothFilters(result);
  return updateFilters(filters, JSON.parse(JSON.stringify(smoothedResult)));
};

const updateFilters = (filters, newFilters) => R.merge(filters, newFilters);

const smoothFilters = (filters) => {
  const newFilters = { selectedCategories: [] };
  if (filters.category) {
    newFilters.selectedCategories.push(filters.category);
  }
  if (filters.or_category) {
    newFilters.selectedCategories.push(filters.or_category);
  }
  return newFilters;
};



// WEBPACK FOOTER //
// ./src/js/utils/get-filters-from-url.js